import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Province } from "../types/canvasTypes";
import HomeLink from "../components/HomeLink";
import { useFetchQuotationContext } from "../context/QuotationListContext";

// Define an array of links

const QuotationList = () => {
  const { getQuotations, loading, quotations, deleteQuotation } =
    useFetchQuotationContext();

  useEffect(() => {
    getQuotations();
  }, []);

  const [sortField, setSortField] = useState("date");
  const [sortDirection, setSortDirection] = useState("desc");

  const handleSort = (field: string) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const handleDelete = async (id: string, name: string, email: string) => {
    await deleteQuotation(id, name, email);
  };

  const sortedLinks = [...quotations].sort((a, b) => {
    const aValue = a[sortField as keyof typeof a];
    const bValue = b[sortField as keyof typeof b];

    if (aValue && bValue) {
      if (aValue < bValue) {
        return sortDirection === "asc" ? -1 : 1;
      } else if (aValue > bValue) {
        return sortDirection === "asc" ? 1 : -1;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  });


  // Render the links as a table
  return (
    <div className="page">
      <HomeLink province={Province.Ontario} />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1>List of Quotations</h1>
        <button className="edit-button" onClick={() => getQuotations(true)}>
          refresh
        </button>
      </div>
      {loading && <div>Loading...</div>}
      <table className="quotation-table">
        <thead>
          <tr>
            <th onClick={() => handleSort("name")}>Name</th>
            <th onClick={() => handleSort("email")}>Email</th>
            <th onClick={() => handleSort("date")}>Date Created</th>
            <th onClick={() => handleSort("createdBy")}>createdBy</th>
            <th onClick={() => handleSort("province")}>Province</th>
            <th>Notes</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {sortedLinks.map((link) => (
            <tr key={link.id}>
              <td>
                <Link to={`/quotations/${link.id}`}>
                  {link.name || "NO NAME"}
                </Link>
              </td>
              <td>{link.email}</td>
              <td>{new Date(link.date.seconds * 1000).toLocaleDateString()}</td>
              <td>{link.createdBy}</td>
              <td>{link.province}</td>
              <td>{link.note}</td>
              <td>
                <button
                  onClick={() => handleDelete(link.id, link.name, link.email)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default QuotationList;
